export const FEATURED_TRIAL_TEMPLATES = [
  {
    key: 'phones_at_dinner',
    title: 'Should phones be allowed at dinner?',
    sideA: 'No phones at table',
    sideB: 'Phones are fine',
    emoji: '📵',
  },
  {
    key: 'weekend_move',
    title: 'Best weekend move?',
    sideA: 'Stay in and recharge',
    sideB: 'Go out and be social',
    emoji: '🎉',
  },
  {
    key: 'morning_coffee',
    title: 'Morning coffee style?',
    sideA: 'Hot coffee always',
    sideB: 'Iced coffee always',
    emoji: '☕',
  },
  {
    key: 'vacation_style',
    title: 'Ideal vacation pace?',
    sideA: 'Packed itinerary',
    sideB: 'Slow and relaxed',
    emoji: '🏖️',
  },
  {
    key: 'music_at_work',
    title: 'Music while working?',
    sideA: 'Silence is best',
    sideB: 'Playlist all day',
    emoji: '🎧',
  },
];

export function pickFeaturedTemplateByKey(templateKey) {
  const key = String(templateKey || '').trim();
  if (!key) return null;
  return FEATURED_TRIAL_TEMPLATES.find((template) => template.key === key) || null;
}
